import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { BpParticulier } from '../model/bp-particulier';

@Injectable({
    providedIn: 'root'
  })
  export class BpParticulierService{
  
    constructor(private _restClientService : RestClientService) { }

    getBpParticulierBycodeclient(codeclient){
        
        return this._restClientService.load<BpParticulier>('bp-particulier/bp-particulier-by-codeclient/'+codeclient);
    }
  
}      

    